import type { ListBuilderConfiguration } from '../../types';
import { allMerchandiserTemplatesList } from './lists/all-merchandiser-templates';

/**
 * Merchandiser template list configuration (PD-15559). Backed by the
 * merchandiser_template entity. The list opens on active templates only —
 * retired ones are configuration history, not something an operator is
 * choosing from — and the Status chip brings them back into view.
 */
export const MERCHANDISER_TEMPLATE_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [allMerchandiserTemplatesList],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [10, 20, 50, 100],
	},
	filters: {
		activeFilters: ['merchandiserTemplateSearch', 'merchandiserTemplateActive'],
		defaultFilters: {
			merchandiserTemplateActive: { id: 'active', label: 'Active' },
		},
	},
	tableSorts: [
		{
			id: 'merchandiser-template-name',
			name: 'Name (A-Z)',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'name',
					objectTable: 'merchandiser_template',
				},
			],
			description: 'Sort templates by name',
		},
		{
			id: 'merchandiser-template-name-desc',
			name: 'Name (Z-A)',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'name',
					objectTable: 'merchandiser_template',
				},
			],
			description: 'Sort templates by name, descending',
		},
	],
	objects: [
		{
			baseUrl: '/distribution/merchandiser-templates',
			objectLabel: 'Merchandiser Template',
			objectTable: 'merchandiser_template',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'id', fieldLabel: 'ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
				{ fieldName: 'description', fieldLabel: 'Description' },
				{ fieldName: 'locationCount', fieldLabel: 'Locations' },
				{ fieldName: 'sensorCount', fieldLabel: 'Sensors' },
				{ fieldName: 'activeLabel', fieldLabel: 'Active' },
			],
		},
	],
};
